// Masthead skeleton: MastheadSkeletonSSR composes @ldp-web/component-library skeletons
// (TopBarSkeleton, MastHeadMainBarSkeleton). LogoData remains in masthead-ssr-types.
export { MastheadSkeletonSSR } from './masthead-skeleton-ssr';
export type { MastheadSkeletonSSRProps } from './masthead-skeleton-ssr';
